module.exports = __webpack_public_path__ + "static/img/DSC_0061.28cb99b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_0061.jpg
// module id = lkB7
// module chunks = 0